import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-section-company',
  templateUrl: './section-company.component.html',
  styleUrls: ['./section-company.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SectionCompanyComponent {
  constructor() {}
}
